export default "__VITE_ASSET__DYdCE1cf__"